/**
 * CommentBubble - 评论气泡组件
 * 用于在 PostCard 上显示最新评论
 */

import React from 'react';
import { Avatar } from 'antd';
import '../../styles/CommentBubble.css';

export interface CommentBubbleProps {
  /** 评论内容 */
  content: string;
  /** 评论者头像 URL */
  avatarUrl?: string | null;
  /** 评论者用户名 */
  username: string;
  /** 最大显示字符数，超出截断 */
  maxLength?: number;
}

export const CommentBubble: React.FC<CommentBubbleProps> = ({
  content,
  avatarUrl,
  username,
  maxLength = 20,
}) => {
  // 截断评论内容
  const truncatedContent = content.length > maxLength
    ? content.slice(0, maxLength) + '...'
    : content;

  // 生成随机旋转角度（参考 CloudItemCard）
  const rotation = React.useMemo(() => {
    const angle = 2 + Math.random() * 8;
    const direction = Math.random() > 0.5 ? 1 : -1;
    return angle * direction;
  }, []);

  // 生成随机 top 位置（-12 到 24）
  const randomTop = React.useMemo(() => {
    return -12 + Math.random() * 20; 
  }, []);

  return (
    <div
      className="comment-bubble"
      style={{
        transform: `rotate(${rotation}deg)`,
        top: `${randomTop}px`,
      }}
    >
      <span className="comment-bubble-content">{truncatedContent}</span>
      <Avatar
        src={avatarUrl}
        className="comment-bubble-avatar"
      >
        {username?.[0]}
      </Avatar>
      {/* 气泡尾巴 */}
      <div className="comment-bubble-tail" />
    </div>
  );
};

export default CommentBubble;
